import React, { useState, useEffect } from 'react';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import ColEdit from '../../../../components/ColEdit/ColEdit';
import GridDefaultShimmer from '../../../../components/GridDefaultShimmer/GridDefaultShimmer';
import HRExtraNew from './New/HRExtraNew';
import { API } from '../../../../API/API';
import ColTag from '../../../../components/ColTag/ColTag';
import { useContext } from 'react';
import { UserContext } from '../../../../context/UserContext';
import { isEdit } from '../../../../SharedFunc/User';

const HRExtra = (props) => {

    const { userInfo } = useContext(UserContext);

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [showNew, setShowNew] = useState(false);
    const [extraid, setExtraId] = useState();

    const getData = async () => {
        let tData = [];
        setLoading(true);
        await API.get('/api/humanresource/payroll/get_extra_list').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                if (response.data?.retdata?.length > 0) {
                    tData = response.data.retdata;
                }
            }
        });
        setLoading(false);
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const [columns] = useState([{
        name: 'Нэмэгдлийн нэр',
        fieldName: 'name',
        minColSize: 'large',
        onRender: (item) => {
            if (edit) {
                return (
                    <ColEdit onClick={() => onEdit(item.extraid)}>{item.name}</ColEdit>
                );
            } else {
                return item.name;
            }
        }
    }, {
        name: 'Нэмэгдлийн төрөл',
        fieldName: 'extratypename'
    }, {
        name: 'Хамаарал',
        fieldName: 'extrafilters',
        minColSize: 'large',
        onRender: (item) => {
            return (
                <ColTag data={item.extrafilters} />
            );
        }
    }]);

    const [loading, setLoading] = useState(false);

    const [edit] = useState(isEdit(userInfo?.accesstoken, ["HR", "MANAGER"]));

    const onNew = () => {
        setExtraId();
        setShowNew(true);
    }

    const onEdit = (p_id) => {
        setExtraId(p_id);
        setShowNew(true);
    }

    const onDismiss = () => {
        setExtraId();
        setShowNew(false);
    }

    const afterSave = () => {
        getData();
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title={'Нэмэгдэл (' + data?.length + ')'}
                buttonTitle={edit ? 'Нэмэгдэл нэмэх' : null}
                onButtonClick={onNew}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                setKey='extraid'
                loading={loading}
                columns={columns}
                data={data}
            />
            <HRExtraNew
                extraid={extraid}
                isOpen={showNew}
                onDismiss={onDismiss}
                afterSave={afterSave}
            />
        </div>
    );
}

export default HRExtra;